<div class="result-row-ctnr">

    <div class="d-grid result-row-grid container-fluid">

        <div class="search-recommendation-ctnr">
            <div class="badge-ctnr d-flex align-items-center" *ngIf="displayRibbon()">
                <komodo-badge label="Recommended"></komodo-badge>
                <div class="icon-ctnr badge-info-icon"
                     [ngbPopover]="isFisherSci ? popContentRecommendedProductsTemplateFS : popContentRecommendedProductsTemplate"
                     placement="top auto"
                     popoverClass="tf-ngb-popover">
                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd"
                              d="M7.00012 2C9.76155 2 12.0001 4.23858 12.0001 7C12.0001 9.76142 9.76155 12 7.00012 12C4.2387 12 2.00012 9.76142 2.00012 7C2.00012 4.23858 4.2387 2 7.00012 2M7.00012 0C3.13413 0 0.00012207 3.13401 0.00012207 7C0.00012207 10.866 3.13413 14 7.00012 14C10.8661 14 14.0001 10.866 14.0001 7C14.0001 5.14348 13.2626 3.36301 11.9499 2.05025C10.6371 0.737498 8.85664 0 7.00012 0ZM6.00012 6.48V10.88H8.00012V6.48H6.00012ZM6.00012 3.24V5.24H8.00012V3.24H6.00012Z"
                              fill="#54545C"/>
                    </svg>
                </div>
            </div>
        </div>

        <div class="assay-id-ctnr">
            <div class="assay-id tf-fs-18 tf-font-bold d-flex position-relative">
                <div class="d-xl-none pe-2">Assay ID:</div>
                <a class="link-like"
                   (click)="productIdClick(product.productID)"
                   (mouseup)="onAssayIdMouseUp()"
                   target="_self"
                   [href]="getProductUrl()">
                    {{ product.productID }}
                </a>
                <div class="copy-t-c-box" *ngIf="showAssayIdCopyToClipboard">
                    <tf-copy-to-clipboard
                            [content]="getContentToCopyToClipboard()"
                            [options]="getCopyToClipboardOptions()"
                            (onCopy)="onCopied($event)">
                    </tf-copy-to-clipboard>
                </div>
            </div>
        </div>

        <div class="select-check-container d-flex justify-content-end align-items-lg-center">
            <div class="mobile-label d-xl-none pe-2">Select</div>
            <tf-result-checkbox [product]="product"></tf-result-checkbox>
        </div>

        <div
                class="save-to-list-ctnr d-flex justify-content-end justify-content-md-center pb-1 px-lg-4 px-md-4 pe-md-0">
            <tf-shared-list
                    [assay]="assayToSharedList"
                    (onItemAddedToList)="onItemAddedToListHandler()">
            </tf-shared-list>
        </div>

        <div class="product-info-ctnr d-xl-none">

            <div class="d-flex">
                <div class="tf-font-bold pe-2">Gene:</div>
                <div class="gene-wrap-ctnr">{{ getGeneSymbolAsString() }}</div>
            </div>

            <div class="d-flex">
                <div class="tf-font-bold pe-2">Species:</div>
                <div>{{ product.species }}</div>
            </div>

            <div class="d-flex"
                 [ngClass]="{ 'clickable' : this.isTranscriptCountGreaterThan0() }"
                 (click)="onClickTranscript()">
                <div class="tf-font-bold pe-2 color-black">Transcripts:</div>
                <div>{{ getTranscriptsCount() }}</div>

            </div>

            <div class="d-flex">
                <div class="tf-font-bold pe-2">Amplicon:</div>
                <div>{{ getAmpliconCount(product.ampliconLength) }}</div>
            </div>

        </div>

        <div class="dye-size-ctnr px-md-3 px-xl-0 d-xl-flex align-items-xl-center">

            <div>

                <div class="tf-font-bold d-xl-none label-top">Size:</div>

                <div class="dye-size-dd">
                    <tf-dropdown
                            class="row-dye-dropdown"
                            size="small"
                            [options]="getDyeOptions()"
                            (onChange)="onDyeChange($event.selectedOption)"
                            [compareFn]="compareDropdown"
                            [(ngModel)]="selectedDye">
                    </tf-dropdown>
                </div>

                <div class="dye-size-dd mt-2">
                    <tf-dropdown
                            class="row-size-dropdown"
                            size="small"
                            [options]="getSizeOptions()"
                            (onChange)="onSizeChange($event.selectedOption)"
                            [compareFn]="compareDropdown"
                            [(ngModel)]="selectedSize">
                    </tf-dropdown>
                </div>

            </div>


        </div>

        <div class="price-ctnr px-3 px-xl-0 d-xl-flex align-items-xl-center">
            <div class="tf-font-medium tf-fs-13">
                <tf-price [sku]="selectedCatalogNum" [classesPriceLabel]="['d-xl-none']"></tf-price>
                <div class="sku-value" (mouseup)="onAssayIdMouseUp()">Catalog # <span class="tf-font-regular">{{ selectedCatalogNum }}</span>
                    <div class="copy-t-c-box" *ngIf="showCatalogNumberCopyToClipboard">
                        <tf-copy-to-clipboard
                                [content]="getContentToCopyToClipboard()"
                                [options]="getCopyToClipboardOptions()"
                                (onCopy)="onCopied($event)">
                        </tf-copy-to-clipboard>
                    </div>
                </div>
                <div class="availability-type tf-font-regular">{{ selectedAvailabity }}</div>
            </div>
        </div>

        <div class="chips-wrapper chips-ctnr d-flex flex-wrap mt-2 mb-lg-2">

            <div class="chip-item" *ngIf="showCitationsChip">
                <core-chip
                    variant="selectable"
                    [label]="getCitationsLabel()"
                    [selected]="isDisplayingSection('Citations')"
                    (selection)="toggleResultSection('Citations')"
                    showicon>
                    <svg *ngIf="isDisplayingSection('Citations')"  slot="icon" width="10" height="14" viewBox="0 0 10 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M3.26839e-05 1.73C-0.00584715 0.787775 0.782346 0.0164177 1.76779 0H8.23214C9.21759 0.0164177 10.0058 0.787775 9.9999 1.73V14L4.99997 10.5L3.26839e-05 14V1.73ZM7.90788 10V2.1L2.15482 2L2.09206 10L4.99997 8L7.90788 10Z"
                            fill="#1B1B1D"/>
                    </svg>
                    <svg *ngIf="!isDisplayingSection('Citations')" slot="icon" width="10" height="14" viewBox="0 0 10 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M3.26839e-05 1.73C-0.00584715 0.787775 0.782346 0.0164177 1.76779 0H8.23214C9.21759 0.0164177 10.0058 0.787775 9.9999 1.73V14L4.99997 10.5L3.26839e-05 14V1.73ZM7.90788 10V2.1L2.15482 2L2.09206 10L4.99997 8L7.90788 10Z"
                            fill="#54545C"/>
                    </svg>
                </core-chip>
            
                <div class="chip-arrow-ctnr d-none d-lg-block" *ngIf="isDisplayingSection('Citations')">
                    <div class="chip-arrow chip-arrow-citations"></div>
                </div>
            </div>

            <div class="chip-item">
                <core-chip
                    variant="selectable"
                    label="Details"
                    [selected]="isDisplayingSection('Details')"
                    (selection)="toggleResultSection('Details')"
                    showicon>
                    <svg *ngIf="isDisplayingSection('Details')" slot="icon" width="12" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M9 2V0H3C1.34 0 0 1.34 0 3V11C0 12.66 1.34 14 3 14H12V2H9ZM10 12H3C2.45 12 2 11.55 2 11H9V4H10V12Z" fill="#1B1B1D"/>
                    </svg>
                    <svg *ngIf="!isDisplayingSection('Details')" slot="icon" width="12" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M9 2V0H3C1.34 0 0 1.34 0 3V11C0 12.66 1.34 14 3 14H12V2H9ZM10 12H3C2.45 12 2 11.55 2 11H9V4H10V12Z" fill="#54545C"/>
                    </svg>
                </core-chip>
            
                <div class="chip-arrow-ctnr d-none d-lg-block" *ngIf="isDisplayingSection('Details')">
                    <div class="chip-arrow"></div>
                </div>
            </div>

            <div class="chip-item" *ngIf="showRelatedArraysChip">
                <core-chip
                    variant="selectable"
                    label="Related arrays"
                    [selected]="isDisplayingSection('Related arrays')"
                    (selection)="toggleResultSection('Related arrays')"
                    showicon>
                    <svg slot="icon" width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12.5 2V10H1.5V2H12.5ZM13 0.5H1C0.45 0.5 0 0.95 0 1.5V10.5C0 11.05 0.45 11.5 1 11.5H13C13.55 11.5 14 11.05 14 10.5V1.5C14 0.95 13.55 0.5 13 0.5Z" fill="#54545C"/>
                        <path d="M3.62 5.24C4.23856 5.24 4.74 4.73856 4.74 4.12C4.74 3.50144 4.23856 3 3.62 3C3.00144 3 2.5 3.50144 2.5 4.12C2.5 4.73856 3.00144 5.24 3.62 5.24Z" fill="#54545C"/>
                        <path d="M7 5.24C7.61856 5.24 8.12 4.73856 8.12 4.12C8.12 3.50144 7.61856 3 7 3C6.38145 3 5.88 3.50144 5.88 4.12C5.88 4.73856 6.38145 5.24 7 5.24Z" fill="#54545C"/>
                        <path d="M10.37 5.24C10.9886 5.24 11.49 4.73856 11.49 4.12C11.49 3.50144 10.9886 3 10.37 3C9.75144 3 9.25 3.50144 9.25 4.12C9.25 4.73856 9.75144 5.24 10.37 5.24Z" fill="#54545C"/>
                        <path d="M3.62 8.99C4.23856 8.99 4.74 8.48856 4.74 7.87C4.74 7.25144 4.23856 6.75 3.62 6.75C3.00144 6.75 2.5 7.25144 2.5 7.87C2.5 8.48856 3.00144 8.99 3.62 8.99Z" fill="#54545C"/>
                        <path d="M7 8.99C7.61856 8.99 8.12 8.48856 8.12 7.87C8.12 7.25144 7.61856 6.75 7 6.75C6.38145 6.75 5.88 7.25144 5.88 7.87C5.88 8.48856 6.38145 8.99 7 8.99Z" fill="#54545C"/>
                        <path d="M10.37 8.99C10.9886 8.99 11.49 8.48856 11.49 7.87C11.49 7.25144 10.9886 6.75 10.37 6.75C9.75144 6.75 9.25 7.25144 9.25 7.87C9.25 8.48856 9.75144 8.99 10.37 8.99Z" fill="#54545C"/>
                    </svg>
                </core-chip>
            
                <div class="chip-arrow-ctnr d-none d-lg-block" *ngIf="isDisplayingSection('Related arrays')">
                    <div class="chip-arrow"></div>
                </div>
            </div>

            <div class="chip-item">
                <core-chip
                    variant="selectable"
                    label="Related products"
                    [selected]="isDisplayingSection('Related products')"
                    (selection)="toggleResultSection('Related products')"
                    showicon>
                    <svg *ngIf="isDisplayingSection('Related products')" slot="icon" width="10" height="15" viewBox="0 0 10 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M9.5 0.655762H0.5V3.65576H1.5V11.1558C1.5 13.0858 3.07 14.6558 5 14.6558C6.93 14.6558 8.5 13.0858 8.5 11.1558V3.65576H9.5V0.655762ZM6.5 11.1558C6.5 11.9858 5.83 12.6558 5 12.6558C4.17 12.6558 3.5 11.9858 3.5 11.1558V7.65576H6.5V11.1558ZM6.5 5.65576H3.5V3.65576H6.5V5.65576Z" fill="#1B1B1D"/>
                    </svg>
                    <svg *ngIf="!isDisplayingSection('Related products')" slot="icon" width="10" height="15" viewBox="0 0 10 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M9.5 0.655762H0.5V3.65576H1.5V11.1558C1.5 13.0858 3.07 14.6558 5 14.6558C6.93 14.6558 8.5 13.0858 8.5 11.1558V3.65576H9.5V0.655762ZM6.5 11.1558C6.5 11.9858 5.83 12.6558 5 12.6558C4.17 12.6558 3.5 11.9858 3.5 11.1558V7.65576H6.5V11.1558ZM6.5 5.65576H3.5V3.65576H6.5V5.65576Z" fill="#54545C"/>
                    </svg>
                </core-chip>
            
                <div class="chip-arrow-ctnr d-none d-lg-block" *ngIf="isDisplayingSection('Related products')">
                    <div class="chip-arrow"></div>
                </div>
            </div>

        </div>

        <div class="add-to-cart-ctnr mt-2 p-2 pe-lg-0 pe-xl-3" [class]="addToCardFSClasses()">

            <komodo-button
                    class="w-100"
                    label="Add to cart"
                    [variant]="isFisherSci ? 'eoutline' : 'outline'"
                    [fullspace]="true"
                    (click)="addToCart()"
                    *ngIf="isAddableToCart"
            >
            </komodo-button>
            <div *ngIf="!isAddableToCart" class="add-to-cart-text">{{cartResponseMessage}}</div>

        </div>

        <div class="gene-ctnr d-none d-xl-block">
            <div class="tf-font-bold d-xl-none pe-2">Gene:</div>
            <span class="gene-wrap-ctnr">{{ getGeneSymbolAsString() }}</span>
        </div>

        <div class="species-ctnr d-none d-xl-block">
            <div class="tf-font-bold d-xl-none pe-2">Species:</div>
            {{ product.species }}
        </div>

        <div class="transcripts-ctnr d-none d-xl-block"
             [ngClass]="{ 'clickable' : this.isTranscriptCountGreaterThan0() }"
             (click)="onClickTranscript()">
            <div class="tf-font-bold d-xl-none pe-2">Transcripts:</div>
            {{ getTranscriptsCount() }}
        </div>

        <div class="amplicon-ctnr d-none d-xl-block">
            <div class="tf-font-bold d-xl-none pe-2">Amplicon:</div>
            {{ getAmpliconCount(product.ampliconLength) }}
        </div>

    </div>

    <div class="drawer-ctnr" [hidden]="!isDisplayingAnySection()">

        <div class="container-fluid">

            <div [hidden]="!isDisplayingSection('Citations')" class="drawer-section-ctnr">
                <div class="close-ctnr" (click)="onClose('Citations')">
                    <svg viewBox="0 0 10 10">
                        <line x1="1" y1="1" x2="9" y2="9"/>
                        <line x1="1" y1="9" x2="9" y2="1"/>
                    </svg>
                </div>
                <ng-template #biozViewContainer></ng-template>
            </div>

            <div [hidden]="!isDisplayingSection('Details')" class="drawer-section-ctnr">
                <div class="close-ctnr" (click)="onClose('Details')">
                    <svg viewBox="0 0 10 10">
                        <line x1="1" y1="1" x2="9" y2="9"/>
                        <line x1="1" y1="9" x2="9" y2="1"/>
                    </svg>
                </div>
                <ng-template #detailsViewContainer></ng-template>
            </div>

            <div [hidden]="!isDisplayingSection('Related products')" class="drawer-section-ctnr">
                <div class="close-ctnr" (click)="onClose('Related products')">
                    <svg viewBox="0 0 10 10">
                        <line x1="1" y1="1" x2="9" y2="9"/>
                        <line x1="1" y1="9" x2="9" y2="1"/>
                    </svg>
                </div>
                <ng-template #relatedProductsViewContainer></ng-template>
            </div>

        </div>

    </div>

</div>

<ng-template #chipsTemplate>

</ng-template>

<ng-template #searchRecommendationTemplate>
    <div class="badge-ctnr">
        <komodo-badge label="Recommended"></komodo-badge>
    </div>
    <div class="icon-ctnr"
         [ngbPopover]="popContentRecommendedProductsTemplate"
         placement="top auto"
         popoverClass="tf-ngb-popover">
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M7.00012 2C9.76155 2 12.0001 4.23858 12.0001 7C12.0001 9.76142 9.76155 12 7.00012 12C4.2387 12 2.00012 9.76142 2.00012 7C2.00012 4.23858 4.2387 2 7.00012 2M7.00012 0C3.13413 0 0.00012207 3.13401 0.00012207 7C0.00012207 10.866 3.13413 14 7.00012 14C10.8661 14 14.0001 10.866 14.0001 7C14.0001 5.14348 13.2626 3.36301 11.9499 2.05025C10.6371 0.737498 8.85664 0 7.00012 0ZM6.00012 6.48V10.88H8.00012V6.48H6.00012ZM6.00012 3.24V5.24H8.00012V3.24H6.00012Z"
                  fill="#A2A2A2"/>
        </svg>
    </div>
</ng-template>

<ng-template #popContentRecommendedProductsTemplate>
    <b>Recommended products</b>
    are evaluated by a proprietary bioinformatic algorithm with additional criteria
    which can be found <a href="https://tinyurl.com/tt8v9ukv" target="_self">here.</a>
</ng-template>

<ng-template #popContentRecommendedProductsTemplateFS>
    <div class="recommended-content-ctnr">
        For the target you selected, we compared all assays for that target, and we recommend this assay for standard
        gene expression experiments because it detects the maximum number of transcripts for your gene of interest. We
        also evaluated the assays based on the following criteria, and the recommended assay best meets the design
        criteria below.

        <ul>
            <li>Does not detect gene products with similar sequence (homologs)</li>
            <li>Is designed across an exon–exon junction</li>
            <li>Is an inventoried product, so you get it faster</li>
            <li>Has a short amplicon, giving you a more efficient PCR reaction</li>
            <li>Does not detect off-target sequences, thus increasing the specificity of your reactions (off-target
                detection may happen when an assay hybridizes with a sequence that occurs more than once in the genome)
            </li>
            <li>Does not map to multiple genes, thus increasing the specificity of your experiment</li>
            <li>Does not target the 5' untranslated region (UTR). The 5' UTR of transcripts can have variable sequence
                between transcripts.
            </li>
        </ul>
    </div>
</ng-template>
